module.exports = __webpack_public_path__ + "img/slider_about_large_2.ea3589c9.png";